<template>
  <div>
    <el-tabs>
      <el-tab-pane
        :lazy="true"
        :label="isLoggedIn && id === user.id ? '活跃话题（公开）' : '活跃话题'"
        tabindex="0"
      >
        <UserTopic :id="id"></UserTopic>
      </el-tab-pane>
      <el-tab-pane
          v-if="isLoggedIn && id === user.id"
          :lazy="true"
          label="匿名话题（公开但匿名）"
          tabindex="1"
      >
        <UserTopic :id="id" type="anonymous"></UserTopic>
      </el-tab-pane>
      <el-tab-pane
        :lazy="true"
        :label="isLoggedIn && id === user.id ? '回复（公开）' : '回复'"
        tabindex="2"
      >
        <UserReply :id="id"></UserReply>
      </el-tab-pane>
      <el-tab-pane
        :lazy="true"
        label="已关闭话题（仅对会员用户可见）"
        tabindex="3"
      >
        <UserTopic
          :id="id"
          type="closed"
          v-if="id === user.id || user.subscribed"
        ></UserTopic>
        <p v-else>
          仅会员可见， <a href="/user/subscription">点击购买会员。</a>
        </p>
      </el-tab-pane>
      <el-tab-pane
        v-if="isLoggedIn && id === user.id"
        :lazy="true"
        label="话题草稿（仅对自己可见）"
        tabindex="3"
      >
        <UserTopic :id="id" type="unpublished"></UserTopic>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapState } from "vuex";
import UserTopic from "../components/UserTopicIndex.vue";
import UserReply from "../components/UserReplyIndex.vue";

export default {
  props: ["id"],
  computed: {
    ...mapGetters(["isLoggedIn"]),
    ...mapState(["user"])
  },
  components: {
    UserTopic,
    UserReply
  }
};
</script>
